import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { StepWithAlerts } from '../components/StepWithAlerts/StepWithAlerts.js';
import { PupillaryDistanceContent } from '../PrescriptionStep/components/PupillaryDistanceContent/PupillaryDistanceContent.js';
import { PrescriptionFormContainer } from '../PrescriptionStep/components/PrescriptionForm/PrescriptionFormContainer.js';

var PrescriptionFormStep = (_param)=>{
    var { description , image  } = _param, stepWithAlertsProps = swcHelpers.objectWithoutProperties(_param, [
        "description",
        "image"
    ]);
    const hasExtraInfo = Boolean(description || image);
    return /*#__PURE__*/ React__default.createElement(StepWithAlerts, swcHelpers.extends({}, stepWithAlertsProps), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-form-step"
    }, hasExtraInfo && /*#__PURE__*/ React__default.createElement(PupillaryDistanceContent, {
        className: "rx-form-step__pd-content",
        description: description,
        image: image
    }), /*#__PURE__*/ React__default.createElement(PrescriptionFormContainer, {
        className: "rx-form-step__form"
    })));
};

export { PrescriptionFormStep };
//# sourceMappingURL=PrescriptionFormStep.js.map
